import { https } from "../http";

/**
 * Validate a discount code at checkout
 * @param {{ code: string, planId?: string, userId?: string }} data
 * @returns {Promise<{ valid: boolean, reason: string, discountCode?: object }>}
 */
export const validateDiscountCode = async (data) => {
  try {
    const response = await https().post("/discount-codes/validate", data);
    return response?.data;
  } catch (error) {
    return {
      valid: false,
      reason: error?.response?.data?.message || "Failed to validate discount code",
    };
  }
};
